export const rootPaths = {
  HOME: "/",
  HOME_AFTER_PAYMENT: "/payment/:status?",
  PAYMENT_REDIRECT: "/payment-redirect",
  LOGIN: "/login",
  LOGOUT: "/logout",
};
